<template>
    <div class="container-fluid p-0">
        <span v-if="!loading">
            <b-row>
                <b-row class="m-md-3 container-fluid">
                    <b-card-header header-bg-variant="primary" header-text-variant="light"
                                   class="rounded m-md-3 container-fluid">
                        {{ $t('settings.device_parameters') }}
                    </b-card-header>
                </b-row>
                <b-row>
                    <b-row class="m-md-3 container-fluid">
                        <b-col>{{ $t('settings.firmware.version') }}:
                            {{firmwareCurrentVersion}}
                        </b-col>
                        <b-col>{{ $t('settings.firmware.version_update_time') }}: {{firmwareCurrentUpdateTime}}</b-col>
                    </b-row>
                    <b-row v-if="brandConfig.showFirmwareDescriptions" class="m-md-3 container-fluid">
                        <b-col>
                            {{$t('firmware.description')}}:
                            {{currentFirmwareDescription}}
                        </b-col>
                    </b-row>
                    </b-row>
                <b-row class="m-md-3 container-fluid">
                    <b-col class="ml-3">
                        <b-form @submit.prevent="saveFirmware">
                            <label class="mr-sm-2" for="device_firmware">{{$t('device_group_actions.set_firmware')}}</label>
                            <b-form-select
                                id="device_firmware"
                                class="mb-2 mr-sm-2 mb-sm-0"
                                :value="null"
                                v-model="firmwareId"
                                :options="firmwareList"
                                value-field="id"
                                text-field="version"
                            ></b-form-select>

                            <div v-if="brandConfig.showFirmwareDescriptions">
                                {{$t('firmware.description')}}: {{getDescription()}}
                            </div>

                            <div v-if="saveFirmwareSuccess" class="text-success">
                              {{$t('saved_success')}} <br>
                            </div>
                            <div v-if="saveFirmwareError" class="text-danger">
                              {{$t('saved_error')}} <br>
                            </div>

                            <b-button
                                :disabled="firmwareId === null"
                                class="mt-2"
                                type="submit"
                                variant="primary"
                            >{{$t('save')}}</b-button>
                        </b-form>
                    </b-col>
                </b-row>
            </b-row>
        </span>
    </div>
</template>

<script>
import axios from "axios";
import {brandConfig} from '../../config/brand';

export default {
    name: "Firmware",
    props: {
        id: {
            type: Number
        }
    },
    data() {
        return {
            brandConfig,
            showSuccessAlert: false,
            loading: true,
            firmwareCurrentVersion: null,
            firmwareCurrentUpdateTime: null,
            currentFirmwareDescription: null,
            firmwareCurrent: null,
            firmwareId: null,
            configurationId: null,
            firmwareList: [],
            firmwareListHash: [],
            configurationList: [],
            saveConfigSuccess: false,
            saveConfigError: false,
            saveFirmwareSuccess: false,
            saveFirmwareError: false,
        }
    },
    watch: {
        configurationId: function() {
            this.saveConfigSuccess = false;
            this.saveConfigError = false;
        },
        firmwareId: function() {
            this.saveFirmwareSuccess = false;
            this.saveFirmwareError = false;
        },
    },
    mounted() {
        let props = this;
        axios
            .get('api/v1/devices/' + props.id)
            .then((data) => {
                const device = data.data;

                this.firmwareCurrent = device.firmware.id;

                this.firmwareCurrentVersion = device.firmwareCurrent;

                if (!device.isFirmwareActual) {
                    this.firmwareCurrentVersion = device.firmwareCurrent + ' >> ' + device.firmwareUpdate + ' (' + device.firmwareLoadPercent + '%)'
                }

                this.firmwareCurrentUpdateTime = device.firmware.updateTime;

                this.loadFirmwareList(device.typeId);
                this.loadConfigurationList(device.typeId);

                this.loading = false;
            })
            .catch(() => undefined);
    },
    methods: {
        loadFirmwareList(deviceType) {
            return axios
                .get('api/v1/firmwares/device-type/' + deviceType)
                .then((data) => {
                    this.firmwareList = [
                        {
                            id: null,
                            version: this.$t('select_firmware')
                        }
                    ]

                    this.firmwareList = this.firmwareList.concat(data.data.rows)

                    this.firmwareList.forEach(
                        item => {
                            this.firmwareListHash[item.id] = item;
                            if (this.firmwareCurrent === item.id) {
                                this.currentFirmwareDescription = item.description;
                            }
                        }
                    );
                })
                .catch(() => undefined);
        },
        getDescription() {
            if (this.firmwareListHash[this.firmwareId] !== undefined) {
                return this.firmwareListHash[this.firmwareId].description;
            }

            return null;
        },
        loadConfigurationList(deviceType) {
            axios
                .get('api/v1/configurations/device-type/' + deviceType)
                .then((data) => {
                    this.configurationList = [
                        {
                            id: null,
                            name: this.$t('select_configuration')
                        }
                    ]

                    this.configurationList = this.configurationList.concat(data.data.rows)
                })
                .catch(() => undefined);
        },
        saveFirmware() {
            if (this.firmwareId === null) return;
            this.saveFirmwareSuccess = false;
            this.saveFirmwareError = false;
            return axios
                .post('api/v1/devices/' + this.id + '/firmware/' + this.firmwareId)
                .then(() => {
                    // console.log(response);
                    this.saveFirmwareSuccess = true
                    this.$emit('device:changed')
                })
                .catch(error => {

                    console.log(error);
                    this.saveFirmwareError = true
                })
        },
        saveConfig() {
            axios
                .post('api/v1/devices/' + this.id + '/savedConfig/' + this.configurationId)
                .then(() => {
                    // console.log(response);
                    this.saveConfigSuccess = true
                    this.$emit('device:changed')
                })
                .catch(error => {

                    console.log(error);
                    this.saveConfigError = true;
                })
        }
    }
}
</script>

<style scoped>

</style>
